// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/main.scss
// module id = 127
// module chunks = 0